import { MUpdatePrice } from "../../../../../../server/routes/logUpdated/price/types";
import usePageLogUpdatedPriceContext from "./usePageLogUpdatedPriceContext";

const useExpanded = (logId: MUpdatePrice["id"]) => {
  const { expanded } = usePageLogUpdatedPriceContext();
  const isExpanded = expanded.value.indexOf(logId) !== -1;
  return {
    isExpanded,
    update: (status: boolean) => {
      const index = expanded.value.indexOf(logId);
      if (status) {
        if (index === -1) {
          expanded.update([...expanded.value, logId]);
        }
      } else {
        if (index !== -1) {
          expanded.value.splice(index, 1);
          expanded.update([...expanded.value]);
        }
      }
    },
  };
};

export default useExpanded;
